export enum EAssessmentStatus {
    NONE = 'NONE',
    APPROVED = 'APPROVED',
    FAILED = 'FAILED'
}